import * as ApiRoutes from "../../routes/routeConstants/apiRoutes";
import axiosInstance from "../../interceptor/axiosInstance";
import _axiosInstance from "../../interceptor/_axiosInstance";
import { deserialize, serialize } from "serializr";
import Notification from "../../shared/components/Notification";
import { NotificationTypes } from "../../enums/notificationTypes";
import {
  JoinLiveClassModel,
  LiveClassCreateModel,
  LiveClassModel,
} from "../../models/InstituteModel/liveClass.model";
import { generatePath } from "react-router-dom";
import { PaginationModel } from "../../models/PaginationModel/pagination.model";
import { LiveClassParticipants } from "../../models/reports/zoom.model";

export default class LiveClassService {
  static fetchLiveClasses(
    params: {
      page: number;
      pageSize: number;
      instituteId: number;
      branchId?: number;
      branchClassRoomId?: number;
      sectionId?: number;
      subjectId?: number;
      search?: string;
    },
    onSuccess: (value: LiveClassModel[], meta: any) => void,
    onError: Function,
    onFinal: () => void
  ) {
    axiosInstance
      .get(
        generatePath(ApiRoutes.INSTITUTE_LIVE_CLASSES, {
          instituteId: params?.instituteId,
        }),
        {
          params: {
            page: params?.page,
            page_size: params?.pageSize,
            branch_id: params?.branchId,
            branch_class_room_id: params?.branchClassRoomId,
            section_id: params?.sectionId,
            subject_id: params?.subjectId,
            search: params?.search
          },
        }
      )
      .then((response) => {
        const data = deserialize(
          LiveClassModel,
          response.data["live_classes"]["live_classes"]
        ) as LiveClassModel[];

        onSuccess(data, { totalCount: response['data']['total_count'] });
      })
      .catch((error) => {
        console.log(error);
        const { response } = error;
        Notification({
          message: "Failed",
          description: response?.data?.error,
          type: NotificationTypes.ERROR,
        });
        onError();
      })
      .finally(() => {
        onFinal();
      });
  }

  // static createLiveClass(
  //   instituteId: number,
  //   data: LiveClassCreateModel,
  //   onSuccess: Function,
  //   onError: Function,
  //   onFinal: () => void
  // ) {
  //   const payload = { live_class: serialize(LiveClassCreateModel, data) };
  //   axiosInstance
  //     .post(
  //       generatePath(ApiRoutes.INSTITUTE_LIVE_CLASS_CREATE, { instituteId }),
  //       payload
  //     )
  //     .then((response) => {
  //       const data = deserialize(LiveClassModel, response.data["live_class"]);
  //       onSuccess(data);
  //     })
  //     .catch((error) => {
  //       const { response } = error;
  //       Notification({
  //         message: "Failed",
  //         description: response?.data?.error,
  //         type: NotificationTypes.ERROR,
  //       });
  //       onError();
  //     })
  //     .finally(() => {
  //       onFinal();
  //     });
  // }

  static createLiveClass(
    data: LiveClassCreateModel,
    onSuccess: Function,
    onError: Function,
    onFinal: () => void
  ) {
    const payload = serialize(LiveClassCreateModel, data);
    _axiosInstance
      .post(ApiRoutes.LIVE_CLASS_CREATE_UPDATE, payload)
      .then((response) => {
        if (response.data.isSuccess) {
          Notification({ message: "Create", description: "create successfully", type: NotificationTypes.SUCCESS });
        } else {
          Notification({ message: "Error", description: response.data.message, type: NotificationTypes.ERROR });
        }
        onSuccess(data);
      })
      .catch((error) => {
        onError();
      })
      .finally(() => {
        onFinal();
      });
  }


  // static updateLiveClass(
  //   liveClassId: number,
  //   data: LiveClassCreateModel,
  //   onSuccess: Function,
  //   onError: Function,
  //   onFinal: () => void
  // ) {
  //   const API_URL = generatePath(ApiRoutes.INSTITUTE_LIVE_CLASS, {
  //     liveClassId,
  //   });
  //   const payload = { live_class: serialize(LiveClassCreateModel, data) };

  //   axiosInstance
  //     .put(API_URL, payload)
  //     .then((response) => {
  //       const data = deserialize(LiveClassModel, response.data["live_class"]);
  //       onSuccess(data);
  //     })
  //     .catch((error) => {
  //       const { response } = error;
  //       Notification({
  //         message: "Failed",
  //         description: response?.data?.error,
  //         type: NotificationTypes.ERROR,
  //       });
  //       onError();
  //     })
  //     .finally(() => {
  //       onFinal();
  //     });
  // }


  static updateLiveClass(
    liveClassId: number,
    data: LiveClassCreateModel,
    onSuccess: Function,
    onError: Function,
    onFinal: () => void
  ) {
    const payload = serialize(LiveClassCreateModel, data);
    _axiosInstance
      .post(ApiRoutes.LIVE_CLASS_CREATE_UPDATE, { ...payload, liveClassId })
      .then((response) => {
        if (response.data.isSuccess) {
          Notification({ message: "Create", description: "update successfully", type: NotificationTypes.SUCCESS });
        } else {
          Notification({ message: "Error", description: response.data.message, type: NotificationTypes.ERROR });
        }
        onSuccess(data);
      })
      .catch((error) => {
        onError();
      })
      .finally(() => {
        onFinal();
      });
  }
  static deleteLiveClass(
    liveClassId: number,
    onSuccess: Function,
    onError: Function,
    onFinal: () => void
  ) {
    const API_URL = generatePath(ApiRoutes.INSTITUTE_LIVE_CLASS, {
      liveClassId,
    });

    axiosInstance
      .delete(API_URL)
      .then((response) => {
        onSuccess();
      })
      .catch((error) => {
        const { response } = error;
        Notification({
          message: "Failed",
          description: response?.data?.error,
          type: NotificationTypes.ERROR,
        });
        onError();
      })
      .finally(() => {
        onFinal();
      });
  }

  //   static updateLiveClass(
  //     LiveClass: LiveClass,
  //     onSuccess: Function,
  //     onError: Function,
  //     onFinal: () => void
  //   ) {
  //     const API_URL = ApiRoutes._LIVE_CLASSS + "/" + LiveClass.id;
  //     const LiveClassJSON = serialize(LiveClass);
  //     axiosInstance
  //       .put(API_URL, LiveClassJSON)
  //       .then((response) => {
  //         const LiveClass = deserialize(LiveClass, response.data["LiveClass"]);
  //         onSuccess(LiveClass);
  //       })
  //       .catch((error) => {
  //         const { response } = error;
  //         Notification({
  //           message: "Failed",
  //           description: response?.data?.error,
  //           type: NotificationTypes.ERROR,
  //         });
  //         onError();
  //       })
  //       .finally(() => {
  //         onFinal();
  //       });
  //   }

  //   static deleteLiveClass(
  //     LiveClassId: string,
  //     onSuccess: Function,
  //     onError: Function,
  //     onFinal: () => void
  //   ) {
  //     const API_URL = ApiRoutes._LIVE_CLASSS + "/" + LiveClassId;
  //     axiosInstance
  //       .delete(API_URL)
  //       .then((response) => {
  //         onSuccess();
  //       })
  //       .catch((error) => {
  //         const { response } = error;
  //         Notification({
  //           message: "Failed",
  //           description: response?.data?.error,
  //           type: NotificationTypes.ERROR,
  //         });
  //         onError();
  //       })
  //       .finally(() => {
  //         onFinal();
  //       });
  //   }

  static joinLiveClass_Zoom(
    data: JoinLiveClassModel,
    onSuccess: (value: string) => void,
    onError: Function,
    onFinal: () => void
  ) {
    const payload = serialize(JoinLiveClassModel, data);
    _axiosInstance.post(ApiRoutes.LIVE_CLASS_JOIN_NEW, payload)
      .then((response) => {
        if (response.data.isSuccess) {
          onSuccess(response.data.message);
        } else {
          Notification({ message: "Error", description: 'something went wrong!', type: NotificationTypes.ERROR });
        }
      })
      .catch((error) => {
        onError();
      })
      .finally(() => {
        onFinal();
      });
  }

  static meeting_participants_report(
    data: JoinLiveClassModel,
    onFinal: () => void
  ) {
    const payload = serialize(JoinLiveClassModel, data);
    axiosInstance.get(ApiRoutes.ADMIN_ZOOM_MEETING_PARTICIPANTS, { params: serialize(LiveClassParticipants, payload) })
    .then((response) => new Blob([response.data]))
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          `Meeting participants.xls`,
        );
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode?.removeChild(link);
      })
      .catch((error) => {
        Notification({ message: "Error", description: 'Meeting does not exist on zoom!', type: NotificationTypes.ERROR });
      })
      .finally(() => {
        onFinal();
      });
  }
}
